import React, { useEffect, useMemo, useRef, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import axios from "axios";

const FinancialPopup = ({ data, setOBPopup }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [currencies, setCurrencies] = useState([]);

  const [selectedVoucherType, setSelectedVoucherType] = useState("JV");
  const [selectedVoucherDescription, setSelectedVoucherDescription] =
    useState("Voucher");

  const [pvnoFromAPI, setPVnoFromAPI] = useState("");
  const [maxVoucherNo, setMaxVoucherNo] = useState("");
  const [disableModify, setDisableModify] = useState(true);
  // const [disableGenerate, setDisableGenerate] = useState(true);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [voucherTypeList, setVoucherTypeList] = useState([]);
  const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);
  const [jvDate, setJvDate] = useState(new Date().toISOString().split("T")[0]);
  const [jvRecurringDate, setJvRecurringDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [accounts, setAccounts] = useState([]);
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);
  const [searchVoucherAccountTerm, setSearchVoucherAccountTerm] = useState("");
  const [frequency, setFrequency] = useState("");
  const [value, setValue] = useState("ALL");
  const [inputVoucherValue, setInputVoucherValue] = useState("");
  const [inputVoucherValueAccount, setInputVoucherValueAccount] = useState("");
  const [inputVoucherValueDescription, setInputVoucherValueDescription] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [filteredPDCAccounts, setFilteredPDCAccounts] = useState([]);
  const [ty, setTY] = useState([]);
  const [selectedVoucherAccount, setSelectedVoucherAccount] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyRate, setSelectedCurrencyRate] = useState("");

  const [finalAmount, setFinalAmount] = useState(null);

  const [pdcDropdownOpenIndex, setPdcDropdownOpenIndex] = useState(null);
  const [pdcHighlightedIndex, setPdcHighlightedIndex] = useState(-1);
  const [pdcSearchTerm, setPdcSearchTerm] = useState("");
  const [pdcModalOpen, setPdcModalOpen] = useState(false);
  const [recurringJournal, setRecurringJournal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSavePopup, setOpenSavePopup] = useState(false);
  const [openModifyPopup, setOpenModifiedPopup] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [openErrorModifySnackbar, setOpenErrorModifySnackbar] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [isCheckedRepeatAmount, setIsCheckedRepeatAmount] = useState(false);
  const [isCheckedRepeatDesc, setIsCheckedRepeatDesc] = useState(false);
  const [isVatOn, setIsVatOn] = useState(false);
  const [modifyPopup, setModifyPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [modifyVoucherPage, setModifyVoucherPage] = useState(false);
  const [sumOfDebit, setSumOfDebit] = useState(0);
  const [sumOfCredit, setSumOfCredit] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("daily");
  const [modifyVoucherNo, setModifyVoucherNo] = useState("");

  const [savedVNO, setSavedVNO] = useState("");
  const [modifiedVNO, setModifiedVNO] = useState("");
  const [generatedEntriesState, setGeneratedEntriesState] = useState([]);
  const [setupBillAccount, setSetupBillAccount] = useState("");
  const [selectedAccountsState, setSelectedAccountsState] = useState([]);
  const [entries, setEntries] = useState([]);
  const accountRowContainerRef = useRef(null);
  const accountContainerRef = useRef(null);
  const setupBillContainerRef = useRef(null);
  const accountRefs = useRef([]);
  const voucherDropdownRefs = useRef([]);
  const accountNameRefs = useRef([]);
  const invRefs = useRef([]);
  const deptRefs = useRef([]);
  const descriptionRefs = useRef([]);
  const tyRefs = useRef([]);
  const amountRefs = useRef([]);
  const curRefs = useRef([]);
  const rateRefs = useRef([]);
  const fcBalRefs = useRef([]);
  const chqNoRefs = useRef([]);
  const chqDateRefs = useRef([]);
  const reccurringDateRefs = useRef([]);
  const bankRefs = useRef([]);
  const pdcAccRefs = useRef([]);
  const xRefs = useRef([]);
  const jobCodeRefs = useRef([]);
  const cCenterRefs = useRef([]);
  const costCodeRefs = useRef([]);
  const vatAmtRefs = useRef([]);
  const trnRefs = useRef([]);
  const totalRefs = useRef([]);
  const isVatRefs = useRef([]);
  const pdcDropdownRefs = useRef([]);
  const voucherTypeRefs = useRef(null);
  const [deptCodeList, setDeptCodeList] = useState([]);
  const [deptCode, setDeptCode] = useState("");
  const [obList, setOBList] = useState([]);

  useEffect(() => {
    fetchOBList();
    fetchCurrencyList();
    fetchDeptCodeList();
  }, []);

  const handleChange = (index, field, value) => {
    const cleanValue = value?.trim?.() ?? "";
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        [field]: cleanValue,
      };
      return updatedEntries;
    });
  };

  // const handleChangeAmountEntry = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       AMOUNT: amount,
  //       FCBalAmt: Number(amount / rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeFCBalAmt = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const fcBalAmt = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       FCBalAmt: fcBalAmt,
  //       AMOUNT: Number(fcBalAmt * rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeRate = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const rate = parseFloat(value) || 1;
  //     const fcBalAmt = parseFloat(updated[index].FCBalAmt) || 0;

  //     updated[index] = {
  //       ...updated[index],
  //       rate,
  //       AMOUNT: Number(fcBalAmt * rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeAmountModify = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       amount: amount,
  //       FCBalAmt: Number(amount / rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  const recalculateRow = (row) => {
    const amount = parseFloat(row.amount) || 0;
    const rate = parseFloat(row.rate) || 1;
    const fcBalAmt = parseFloat(row.curamount) || 0;

    // If amount changed → recompute FC
    if (row.amount !== undefined) {
      return { ...row, FCBalAmt: Number(amount / rate).toFixed(2) };
    }
    // If FC changed → recompute amount
    if (row.curamount !== undefined) {
      return { ...row, amount: Number(fcBalAmt * rate).toFixed(2) };
    }
    // If rate changed → recompute amount from FC (or from amount if FC=0)
    const base = fcBalAmt || amount;
    return {
      ...row,
      amount: Number(base * rate).toFixed(2),
      FCBalAmt: Number(base / rate).toFixed(2),
    };
  };

  const handleAmountChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], amount: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  const handleFCChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], FCBalAmt: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  const handleRateChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], rate: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  // const handleCurrencyChange = (index, curno) => {
  //   const cur = currencies.find((c) => c.curno === curno);
  //   const rate = cur?.rate ? parseFloat(cur.rate) : 1;

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     updated[index] = { ...updated[index], curno, rate };
  //     return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
  //   });
  // };

  const handleTyData = (index) => {
    setTY((prev) =>
      prev.map((value, i) =>
        i === index ? (value === "D" ? "C" : "D") : value,
      ),
    );
    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        ty: newEntries[index].ty === "C" ? "D" : "C",
      };
      return newEntries;
    });

    setTimeout(() => {
      // wait until new row is rendered
      // const lastIndex = amountRefs.current.length - 1;
      const lastIndex = amountRefs.current.length;
      amountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
    // amountRefs.current[index + 1]?.focus();
  };

  //   const handleDropdownSelectAccount = (rowIndex, acc) => {
  //     setSelectedVoucherAccount(acc);
  //     handleChange(rowIndex, "account", acc.ACCOUNT);
  //     handleChange(rowIndex, "description", acc.DESCRIPTION);
  //     setDropdownOpenIndex(null);
  //     setHighlightedIndex(-1);
  //     invRefs.current[rowIndex]?.focus(); // focus reference input

  //     setSelectedAccountsState((prev) => {
  //       const updated = [...prev];
  //       updated[rowIndex] = true;
  //       return updated;
  //     });
  //   };

  const handleAddRow = () => {
    const lastRow = entries.length > 0 ? entries[entries.length - 1] : null;
    setEntries([
      ...entries,
      {
        jvdate: "",
        dept: "",
        INV: "",
        DESCR: "",
        ty: lastRow?.ty === "D" ? "C" : "D",
        amount: 0,
        CUR: "AED",
        rate: 1,
        FCBalAmt: 0,
        JOBCODE: "",
        costCode: "",
      },
    ]);
    setTY((prev) => [...prev, lastRow?.ty === "D" ? "C" : "D"]);

    setTimeout(() => {
      // wait until new row is rendered
      const lastIndex = accountRefs.current.length - 1;
      accountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
  };

  const handleCurrencyChange = (index, value) => {
    const selected = currencies.find((cur) => cur.curno === value);
    const rate = parseFloat(selected?.rate) || 1;

    setEntries((prev) => {
      const updated = [...prev];
      const current = updated[index];

      const amount = parseFloat(current.AMOUNT) || 0;
      const fcBalAmt = parseFloat(current.FCBalAmt) || 0;

      updated[index] = {
        ...current,
        curno: selected.curno,
        rate,
        AMOUNT: amount
          ? Number(amount).toFixed(2)
          : Number(fcBalAmt * rate).toFixed(2),
        FCBalAmt: fcBalAmt
          ? Number(fcBalAmt).toFixed(2)
          : Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  const fetchOBList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${company_code_from_local_storage}/ACCOPENING/-/-/${data.accountNo}/${currentSelectedDepartment}/-/-`;
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${COMPANY_CODE}/ACCOPENING/-/-/${data.accountNo}/${currentSelectedDepartment}/-/-`;

    try {
      const response = await axios.get(url);

      console.log("Response OB Data:", response.data);
      setOBList(response.data);
      const mappedData = response.data.map((item) => ({
        account: item.account || "",
        jvdate: item.jvdate ? item.jvdate.split("T")[0] : "", // format date
        dept: item.deptno?.trim() || "",
        INV: item.ref || "", // your INV column seems to hold "ref"
        DESCR: item.entry_ref || "",
        ty: item.type || item.accountype || "", // type (D/C)
        amount: item.amount || 0,
        curno: item.curno || "",
        rate: item.rate || 1,
        curamount: item.curamount || 0,
        JOBCODE: item.job_code || "",
        costCode: item.COSTCODE || item.costc || "",
        selected: false, // default unchecked
      }));

      setEntries(mappedData);
    } catch (err) {
      console.error("Error OB fetching data:", err);
      setCurrencies([]);
    }
  };

  const fetchCurrencyList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    // const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    try {
      //   const response = await requestCurrencyList({
      //     url: url,
      //     method: "GET",
      //     timeout: 10000,
      //   });

      const response = await axios.get(url);

      console.log("Response", response.data);
      setCurrencies(response.data || []);

      // Default currency from the fetched data
      if (response && response.length > 0) {
        // const defaultCurrency = response[0];
        const defaultCurrency = response.find((item) => item.rate === 1);
        // console.log("🚀 ~ fetchCurrencyList ~ defaultCurrency:", defaultCurrency)

        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  const fetchDeptCodeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DEPTLIST/-/-`;
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`;

    try {
      const response = await axios.get(apiURL);
      console.log("🚀 ~ fetchDeptCodeList ~ response:", response.data);
      const data = response.data;
      setDeptCodeList(data || []);
    } catch (err) {
      console.error("Error while fetching accountlist", err);
    }
  };

  const handleSave = async () => {
    console.log("Saved:", entries);
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;

    const saveOBPayload = () => {
      const payload = entries.map((row) => ({
        cmpcode: company_code_from_local_storage,
        // operation: "ENTRY",
        operation: obList.length > 0 ? "EDIT" : "ENTRY",
        JVTYPE: "OP",
        TYPE_NO: "-99999",
        JVDATE: row.jvdate || "",
        CUST_ACC: data.accountNo || "",
        ACCDESC: data.customerName || "",
        AMOUNT: String(row.amount || "0"),
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage,
        // DEPTNO: "MAIN",
        DEPTNO: row.dept || "",
        COMMENTS: "",
        // USERID: user_from_local_storage,
        USERID: "ADMIN",
        job_code: row.JOBCODE || "",
        sman_code: "",
        costc: "",
        chqno: "",
        chqdate: null,
        rate: row.rate || "1",
        pdcstatus: "",
        pdc_acc: "0",
        reason: "",
        account: data.accountNo || "",
        jvnum: "-99999",
        ref: row?.INV || "",
        entry_ref: row.DESCR || "",
        type: row.ty || "",
        curno: row.curno || "",
        curamount: String(row.curamount) || "0",
        // user_id: user_from_local_storage,
        user_id: "ADMIN",
        accountype: row.ty || "",
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: "",
        due_date: null,
        doc_date: null,
        month: "1",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: "",
        ttref: "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: "0",
        COSTCODE: row.costCode || "",
      }));

      return payload;
    };

    const finalSaveOBPayload = saveOBPayload();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccOpenReg`;
    try {
      const response = await axios.post(apiUrl, finalSaveOBPayload, config);

      console.log("Voucher data Modified:", response.data);
      alert(
        obList.length > 0
          ? "Opening balance modified successfully!"
          : "Opening balance saved successfully!",
      );
      fetchOBList();
    } catch (error) {
      console.log("error while saving reciept", error);
      alert("Error saving opening balance. Please try again.");
    }
  };

  const handleDeleteSelected = () => {
    setEntries((prev) => prev.filter((row) => !row.selected));
  };

  const totalAmount = useMemo(() => {
    return entries
      .reduce((sum, row) => {
        const amt = parseFloat(row.amount) || 0;
        return sum + amt;
      }, 0)
      .toFixed(2);
  }, [entries]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      {/* Modal Container: Flex layout with dynamic height limits to prevent overflow */}
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] flex flex-col p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-center border-b border-gray-100 pb-3 mb-4">
          <h2 className="text-lg font-bold text-gray-800">
            Opening Balance Details
          </h2>
          <button
            onClick={() => setOBPopup(false)}
            className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition"
          >
            ✕
          </button>
        </div>

        {/* Top Form & Controls Wrapper */}
        <div className="flex-shrink-0">
          {/* Row 1: Account Info Grid (3 Columns) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="flex flex-col">
              <label className="text-xs font-semibold text-gray-500 mb-1 tracking-wide">
                Account
              </label>
              <input
                type="text"
                value={data.accountNo}
                readOnly
                className="w-full px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 text-sm border border-gray-200 outline-none focus:border-blue-400 transition"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-xs font-semibold text-gray-500 mb-1 tracking-wide">
                Name
              </label>
              <input
                type="text"
                value={data.customerName}
                readOnly
                className="w-full px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 text-sm border border-gray-200 outline-none focus:border-blue-400 transition"
              />
            </div>

            <div className="hidden md:block" />
          </div>

          {/* Row 2: Actions Bar & Total Display */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 py-3 border-t border-b border-gray-100 mb-4">
            {/* Buttons Group */}
            <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
              <button
                onClick={handleAddRow}
                className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-medium px-4 py-2 rounded-lg active:scale-95 transition text-sm whitespace-nowrap"
              >
                <Plus className="w-4 h-4" />
                Add Row
              </button>

              <button
                onClick={handleDeleteSelected}
                disabled={!entries.some((r) => r.selected)}
                className="flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 disabled:opacity-40 disabled:hover:bg-red-500 text-white font-medium px-4 py-2 rounded-lg disabled:cursor-not-allowed active:scale-95 transition text-sm whitespace-nowrap"
              >
                <Trash2 className="w-4 h-4" />
                Delete
              </button>

              <button
                onClick={handleSave}
                className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-black text-white font-medium px-4 py-2 rounded-lg active:scale-95 transition text-sm whitespace-nowrap"
              >
                <Save className="w-4 h-4" />
                {obList.length > 0 ? "Modify" : "Save"}
              </button>
            </div>

            {/* Total Display */}
            <div className="text-base font-semibold text-right w-full sm:w-auto">
              <span className="text-gray-500">Total:</span>{" "}
              <span className="text-blue-600 font-bold ml-1">
                {totalAmount}
              </span>
            </div>
          </div>
        </div>

        {/* Scrollable Table Block: Dynamically takes up remaining height without overflow */}
        <div className="flex-grow overflow-auto border border-gray-200 rounded-lg bg-white">
          <table className="min-w-full border-collapse text-sm">
            <thead className="bg-gray-50 sticky top-0 z-20 shadow-[0_1px_0_0_rgba(229,231,235,1)]">
              <tr>
                <th className="px-3 py-2 text-center min-w-[50px] w-[50px]">
                  <input
                    type="checkbox"
                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                    checked={
                      entries.length > 0 && entries.every((e) => e?.selected)
                    }
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setEntries((prev) =>
                        prev.map((entry) => ({
                          ...entry,
                          selected: checked,
                        })),
                      );
                    }}
                  />
                </th>
                <th className="px-3 py-2 text-center font-semibold text-gray-600 min-w-[60px] w-[60px]">
                  SL No.
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[140px]">
                  Date
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[140px]">
                  Department
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[140px]">
                  Reference
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[200px]">
                  Description
                </th>
                <th className="px-3 py-2 text-center font-semibold text-gray-600 min-w-[70px]">
                  TY
                </th>
                <th className="px-3 py-2 text-right font-semibold text-gray-600 min-w-[130px]">
                  Amount
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[150px]">
                  Cur
                </th>
                <th className="px-3 py-2 text-right font-semibold text-gray-600 min-w-[110px]">
                  Rate
                </th>
                <th className="px-3 py-2 text-right font-semibold text-gray-600 min-w-[130px]">
                  FC Amount
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[130px]">
                  Job Code
                </th>
                <th className="px-3 py-2 text-left font-semibold text-gray-600 min-w-[130px]">
                  Cost Code
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {entries?.map((row, index) => (
                <tr
                  key={index}
                  ref={accountRowContainerRef}
                  onClick={() => setSetupBillAccount(row.account)}
                  className="hover:bg-gray-50 transition-colors"
                >
                  {/* Checkbox */}
                  <td className="px-3 py-1.5 text-center">
                    <input
                      type="checkbox"
                      checked={row?.selected || false}
                      className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setEntries((prev) => {
                          const updated = [...prev];
                          updated[index].selected = checked;
                          return updated;
                        });
                      }}
                    />
                  </td>

                  {/* SL No */}
                  <td className="px-3 py-1.5 text-center text-gray-500 font-medium">
                    {index + 1}
                  </td>

                  {/* Date */}
                  <td className="px-2 py-1">
                    <input
                      type="date"
                      value={
                        row?.jvdate || new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) =>
                        handleChange(index, "jvdate", e.target.value)
                      }
                      onKeyDown={(e) =>
                        e.key === "Enter" && deptRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* Department */}
                  <td className="px-2 py-1">
                    <select
                      ref={(el) => (deptRefs.current[index] = el)}
                      value={row?.dept || ""}
                      onChange={(e) =>
                        handleChange(index, "dept", e.target.value)
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    >
                      <option className="text-gray-400" value="">
                        Select Dept
                      </option>
                      <option value="all">ALL</option>
                      {deptCodeList.map((dept, i) => (
                        <option key={i} value={dept.deptno}>
                          {dept.deptnodesc}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Reference */}
                  <td className="px-2 py-1">
                    <input
                      type="text"
                      onFocus={(e) => e.target.select()}
                      ref={(el) => (invRefs.current[index] = el)}
                      value={row?.INV || ""}
                      onChange={(e) =>
                        handleChange(index, "INV", e.target.value)
                      }
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        descriptionRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* Description */}
                  <td className="px-2 py-1">
                    <input
                      ref={(el) => (descriptionRefs.current[index] = el)}
                      value={row?.DESCR || ""}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) =>
                        handleChange(index, "DESCR", e.target.value)
                      }
                      onKeyDown={(e) =>
                        e.key === "Enter" && tyRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* TY */}
                  <td className="px-2 py-1 text-center">
                    <button
                      ref={(el) => (tyRefs.current[index] = el)}
                      onClick={() => handleTyData(index)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          amountRefs.current[index]?.focus();
                        } else if (e.key === " ") {
                          e.preventDefault();
                          handleTyData(index);
                        }
                      }}
                      className={`px-3 py-1 text-xs font-bold rounded-md text-white transition-colors min-w-[45px] ${
                        row?.ty === "D"
                          ? "bg-emerald-500 hover:bg-emerald-600"
                          : "bg-rose-500 hover:bg-rose-600"
                      }`}
                    >
                      {row?.type || row?.ty}
                    </button>
                  </td>

                  {/* Amount */}
                  <td className="px-2 py-1">
                    <input
                      type="number"
                      ref={(el) => (amountRefs.current[index] = el)}
                      value={row.amount}
                      onChange={(e) =>
                        handleAmountChange(index, e.target.value)
                      }
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) =>
                        e.key === "Enter" && curRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded text-right focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* Cur */}
                  <td className="px-2 py-1">
                    <select
                      ref={(el) => (curRefs.current[index] = el)}
                      value={row.curno}
                      onChange={(e) =>
                        handleCurrencyChange(index, e.target.value)
                      }
                      onKeyDown={(e) =>
                        e.key === "Enter" && rateRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    >
                      {currencies.map((c) => (
                        <option key={c.curno} value={c.curno}>
                          {c.curno} - {c.cur.trim()}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Rate */}
                  <td className="px-2 py-1">
                    <input
                      type="number"
                      step="any"
                      ref={(el) => (rateRefs.current[index] = el)}
                      value={row.rate}
                      onChange={(e) => handleRateChange(index, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) =>
                        e.key === "Enter" && fcBalRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded text-right focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* FC Amount */}
                  <td className="px-2 py-1">
                    <input
                      type="number"
                      ref={(el) => (fcBalRefs.current[index] = el)}
                      value={row.curamount}
                      onChange={(e) => handleFCChange(index, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) =>
                        e.key === "Enter" && jobCodeRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded text-right focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* Job Code */}
                  <td className="px-2 py-1">
                    <input
                      type="text"
                      ref={(el) => (jobCodeRefs.current[index] = el)}
                      value={row?.JOBCODE || ""}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) =>
                        handleChange(index, "JOBCODE", e.target.value)
                      }
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        costCodeRefs.current[index]?.focus()
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>

                  {/* Cost Code */}
                  <td className="px-2 py-1">
                    <input
                      type="text"
                      ref={(el) => (costCodeRefs.current[index] = el)}
                      value={row?.costCode || ""}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) =>
                        handleChange(index, "costCode", e.target.value)
                      }
                      className="w-full px-2 py-1 border border-gray-200 rounded focus:border-blue-400 focus:ring-1 focus:ring-blue-400 outline-none text-sm bg-transparent"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinancialPopup;
